import type { LeadSubmitResponse } from '@highereducation/delivery-system';

/**
 * Flattens the LDS v4 submit response's identifier fields into the single
 * `partnerIdentifiers` record the CTA interpolators read from (EDUN-14483).
 *
 * The schema allows a `referenceId` at both the top level and nested inside
 * `partnerIdentifiers`. The top-level field is authoritative, so it is
 * spread last and wins over a same-named nested key.
 */
export function mergePartnerIdentifiers(
  response: LeadSubmitResponse,
): Record<string, string> {
  return {
    ...(response.partnerIdentifiers ?? {}),
    ...(response.referenceId ? { referenceId: response.referenceId } : {}),
  };
}
